// Step-1 opening detector: the endpoint, the input size it was trained at,
// and how to read its output. Other VLM tasks get sibling modules.

import { streamInference } from "../client.js";

const DETECTOR_ENDPOINT = "/api/inference/step1";

// Trained at 2400-4000 px effective edge. Larger images are downscaled by
// the model's smart_resize and fall outside that distribution.
export const DETECTOR_MAX_EDGE_PX = 2400;

export function detectOpenings({ imageB64, token, signal }) {
  return streamInference({ imageB64, endpoint: DETECTOR_ENDPOINT, token, signal });
}

/** Pull the grounding boxes out of a `complete` event. The vLLM response is
 *  OpenAI-shaped; the detections live in the message content as a JSON
 *  string, sometimes wrapped in a ```json fence. */
export function parseDetections(completeEvent) {
  const content = completeEvent?.payload?.choices?.[0]?.message?.content ?? "";
  const text = content
    .trim()
    .replace(/^```[a-zA-Z]*\n?/, "")
    .replace(/\n?```$/, "");
  try {
    const parsed = JSON.parse(text);
    return Array.isArray(parsed) ? parsed : [];
  } catch {
    return [];
  }
}
